/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PluginSkillDistribution,
  PluginSkillDistribution$inboundSchema,
} from "./pluginskilldistribution.js";

/**
 * A page of active plugin skill distributions for the current project.
 */
export type ListSkillDistributionsResult = {
  /**
   * The active plugin skill distributions in this page.
   */
  distributions: Array<PluginSkillDistribution>;
  /**
   * Cursor for the next page; absent when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListSkillDistributionsResult$inboundSchema: z.ZodMiniType<
  ListSkillDistributionsResult,
  unknown
> = z.pipe(
  z.object({
    distributions: z.array(PluginSkillDistribution$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listSkillDistributionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSkillDistributionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSkillDistributionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSkillDistributionsResult' from JSON`,
  );
}
